import { removeEmptyValues as r } from "@partoohub/utils";
import { useQuery as i } from "react-query";
import { useBusinessModalContext as c } from "../BusinessModalContext.js";
import { useBusinessesQueryParams as m } from "./queryParams/business/useBusinessesQueryParams.js";
const a = "businesses", B = ({
  overrideBusinessSearchFilters: t,
  enabled: o = !0
} = {}) => {
  const {
    apiClient: u
  } = c(), n = t ?? m(), s = r(n), e = i([a, "count", s], () => u.business.searchBusinessesCount(s), {
    enabled: o
  });
  return {
    query: e,
    count: e.data?.count ?? void 0
  };
};
export {
  a as BUSINESSES,
  B as useBusinessCount
};
